import {Component, inject, OnInit} from '@angular/core';
import {AConst} from '../../core/a-const.enum';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ConfirmDialogData} from '../../object-edit/confirm-dialog/confirm-dialog.component';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './alert-dialog.component.html',
    styleUrls: ['./alert-dialog.component.scss'],
    standalone: false
})
export class AlertDialogComponent implements OnInit {
  // Injections
  public data: ConfirmDialogData = inject(MAT_DIALOG_DATA);
  public dialogRef: MatDialogRef<AlertDialogComponent> = inject(MatDialogRef);

  AConst = AConst;
  isArray: boolean;

  ngOnInit() {
    this.isArray = Array.isArray(this.data.modalContent);
  }
}
